import service from '@/utils/server';

const modName='/log/xxlJobLog/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const deleteData = data => {
  return service({
    url: modName + 'deleteData',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/log/xxlJobLog/api/index.js